module.exports = __webpack_public_path__ + "prod/1.42.2/img/api-qr-code.654f03fb.png";